// import React from 'react'
// import { Link, useLocation } from 'react-router-dom'

// export const Layout = ({ children }) => {
//     const location = useLocation();

//     const menuItems = [
//         {
//             title: 'Home',
//             path: '/',
//             icon: 'ri-home-9-line',
//         },
//         {
//             title: 'About Us',
//             path: '/about',
//             icon: 'ri-information-line',
//         },
//         {
//             title: 'Testimonials',
//             path: '/testimonials',
//             icon: 'ri-user-community-fill',
//         },
//          {
//             title: 'blogs',
//             path: '/blogs',
//             icon: 'ri-blogger-line',
//         },
//         {
//             title: 'Contact Us',
//             path: '/contact',
//             icon: 'ri-contacts-fill',
//         }
//     ]

//     return (
//         <div>
//             {/* content */}
//             <div className="pb-44 overflow-x-hidden">
//                 {children}
//             </div>


//             {/* footer */}
//             <div className="fixed bottom-10 left-0 right-0">
//                 <div className='flex w-full justify-center'>
//                     {menuItems.map((item, index) => (

//                         <div className='flex flex-col justify-end items-center'>
//                             {location.pathname === item.path && (<div className='flex flex-col items-center'>
//                                 <div className='h-5 w-10 bg-primary rounded-t-full'>

//                                 </div>
//                                 <div className='h-5 w-20 bg-primary rounded-t-full text-center'>
//                                     <i className={`${item.icon} text-secondary text-xl text-white`}></i>
//                                 </div>

//                             </div>)}

//                             <div className={`px-20 bg-primary py-5 ${index === 0 && "rounded-l"} ${index === menuItems.length - 1 && "rounded-r"}
//                          flex items-center justify-center space-x-2`}>
//                                 {location.pathname !== item.path && (<i className={`${item.icon} text-secondary text-xl`}></i>)}
//                                 <Link to={`${item.path}`} className='text-secondary text-xl'>{item.title}</Link>
//                             </div>

//                         </div>

//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Layout















import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export const Layout = ({ children }) => {
    const location = useLocation();
    const [isHovered, setIsHovered] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const menuItems = [
        {
            title: 'Home',
            path: '/',
            icon: 'ri-home-9-line'
        },
        {
            title: 'About Us',
            path: '/about',
            icon: 'ri-information-line'
        },
        {
            title: 'Testimonials',
            path: '/testimonials',
            icon: 'ri-user-community-fill'
        },
        {
            title: 'Blogs',
            path: '/blogs',
            icon: 'ri-blogger-line'
        },
        {
            title: 'Contact Us',
            path: '/contact',
            icon: 'ri-contacts-fill'
        }
    ];

    return (
        /* FIX 1: Added w-full and overflow-x-hidden to the outermost container */
        <div className="flex h-screen w-full overflow-hidden bg-white">

            {/* --- DESKTOP SIDEBAR --- */}
            <aside
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className={`
                    hidden md:flex flex-col h-full bg-slate-900 border-r border-slate-700
                    transition-all duration-300 ease-in-out z-[100] shrink-0
                    ${isHovered ? 'w-64' : 'w-20'}
                `}
            >
                <div className="flex items-center px-4 py-8 overflow-hidden">
                    <div className="min-w-[40px] h-10 bg-orange-500 rounded-lg flex items-center justify-center font-bold text-white shrink-0">
                        <img src="logo.png" alt="" className='w-10'/>
                    </div>
                    {isHovered && <span className="ml-4 text-white font-bold text-xl whitespace-nowrap animate-in fade-in">DIGITAL CANTO</span>}
                </div>
                <nav className="flex flex-col flex-1 px-3 gap-2">
                    {menuItems.map((item, index) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <Link key={index} to={item.path}
                                className={`flex items-center p-4 rounded-xl transition-all duration-200 ${isActive ? 'bg-orange-500 text-white shadow-lg' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}`}
                            >
                                <i className={`${item.icon} text-2xl`}></i>
                                {isHovered && <span className="ml-4 font-medium whitespace-nowrap">{item.title}</span>}
                            </Link>
                        );
                    })}
                </nav>
            </aside>

            {/* --- MAIN AREA --- */}
            {/* FIX 2: min-w-0 ensures flex-child doesn't push beyond parent bounds */}
            <div className="flex flex-col flex-1 min-w-0 h-full overflow-hidden relative">

                {/* --- MOBILE HEADER --- */}
                {/* FIX 3: Changed background to match your logo's dark navy for seamless look */}
                <header className="md:hidden flex h-16 w-full shrink-0 items-center justify-between px-6 bg-[#0B1120] border-b border-slate-800 z-[50]">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-orange-500 rounded flex items-center justify-center font-bold text-white">
                            <img src="logo.png" alt="" className='w-8'/>
                        </div>
                        <span className="text-white font-bold">DIGITAL CANTO</span>
                    </div>
                    <button onClick={() => setIsMobileMenuOpen(true)} className="flex flex-col gap-1.5 focus:outline-none">
                        <span className="w-6 h-0.5 bg-white"></span>
                        <span className="w-6 h-0.5 bg-white"></span>
                        <span className="w-6 h-0.5 bg-white"></span>
                    </button>
                </header>

                {/* --- MOBILE DRAWER --- */}
                <div
                    className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[110] transition-opacity duration-300 md:hidden ${isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                />
                <div className={`fixed top-0 left-0 h-full w-[280px] bg-slate-900 z-[120] transition-transform duration-500 md:hidden ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                    <div className="p-6 border-b border-slate-800 flex justify-between text-white">
                        <span className="font-bold uppercase tracking-widest">Digital Canto</span>
                        <button onClick={() => setIsMobileMenuOpen(false)}><i className="ri-close-line text-2xl"></i></button>
                    </div>
                    <nav className="p-4 flex flex-col gap-2">
                        {menuItems.map((item, index) => (
                            <Link key={index} to={item.path} onClick={() => setIsMobileMenuOpen(false)}
                                className={`flex items-center gap-4 p-4 rounded-xl ${location.pathname === item.path ? 'bg-orange-500 text-white' : 'text-slate-400'}`}
                            >
                                <i className={`${item.icon} text-xl`}></i>
                                <span className="font-medium">{item.title}</span>
                            </Link>
                        ))}
                    </nav>
                </div>

                {/* --- CONTENT AREA (SCROLLABLE) --- */}
                {/* FIX 4: overflow-x-hidden is MANDATORY here to kill that side gap */}
                <main className="flex-1 overflow-y-auto overflow-x-hidden w-full m-0 p-0">
                    <div className="w-full h-full m-0 p-0">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default Layout;